<h2 class="pull-left">Possible matches</h2>


<div class="clearfix"></div>

<div class="bottom-margin">
  <div class="row">
    <div class="col-xs-12">
      <p-table
        [value]="activePlans"
        [lazy]="true"
        [totalRecords]="totalRecords"
        [paginator]="true"
        (onLazyLoad)="loadPlans($event)"
        [rows]="rows"
        [first]="first"
        [showCurrentPageReport]="true"
        selectionMode="single"
        [(selection)]="selectedActivePlan"
        (onRowSelect)="onRowSelect($event)"
        (onRowUnselect)="null"
        (onPage)="pageChange($event)"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
        [rowsPerPageOptions]="[10, 25, 50]"
        stateStorage="session"
        stateKey="state-session-pending-plan-matching"
        >
        <ng-template pTemplate="header">
          <tr>
            @for (key of keys; track key) {
              <th pSortableColumn="{{ key }}">
                {{ tableConfig?.columns[key]?.title }} <p-sortIcon field="{{ key }}"></p-sortIcon>
              </th>
            }
          </tr>
          <tr>
            <th style="width:25%">
              <p-columnFilter
                type="text"
                field="carrier_name"
                [placeholder]="placeholders['carrier_name']"
                ariaLabel="Filter carrier name"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
            <th style="width:25%">
              <p-columnFilter
                type="text"
                field="plan_name"
                [placeholder]="placeholders['plan_name']"
                ariaLabel="Filter plan name"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
            <th style="width:25%">
              <p-columnFilter
                type="text"
                field="authorization_contact"
                [placeholder]="placeholders['authorization_contact']"
                ariaLabel="Filter authorization contact"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
            <th style="width:25%">
              <p-columnFilter
                type="text"
                field="score"
                [placeholder]="placeholders['score']"
                ariaLabel="Filter score"
                [showMenu]="false"
                [showClearButton]="false"
                />
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-activePlan>
          <tr [pSelectableRow]="activePlan">
            @for (key of keys; track key) {
              <td>{{ activePlan?.[key] }}</td>
            }
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <button
    class="btn pull-right"
    [ngClass]="{'btn-secondary': !selectedActivePlan?.id, 'btn-primary': !!selectedActivePlan?.id}"
    (click)="confirmMatch()"
    [disabled]="!selectedActivePlan?.id"
    >
    Confirm match
  </button>
  <button class="btn btn-link pull-right" (click)="openMatchNewActivePlanModal()">New plan</button>
</div>

<div class="bottom-margin" [hidden]="activePlans?.length > 0">
  <div class="empty-state">
    <div class="empty-state-content">
      <span>No plans match your search</span>
    </div>
  </div>
</div>
